import { refreshAccessToken } from '@/features/auth/services/authApi';
import { useAuthStore } from '@/shared/stores/authStore';

let refreshPromise: Promise<boolean> | null = null;

export async function tryRefreshToken(): Promise<boolean> {
  if (refreshPromise) return refreshPromise;

  const refreshToken = localStorage.getItem('auth_refresh_token');
  if (!refreshToken) return false;

  refreshPromise = (async () => {
    try {
      const data = await refreshAccessToken(refreshToken);
      useAuthStore.getState().login(
        data.token, data.username, data.role,
        data.roles, data.permissions, data.refresh_token,
      );
      return true;
    } catch {
      return false;
    } finally {
      refreshPromise = null;
    }
  })();

  return refreshPromise;
}
